import getChats from "app/api/requests/Chat/getChats";
import { ClientLocal } from "app/api/types";
import { DateTime } from "luxon";
import getChatToken from "app/api/getChatToken";

export const UPDATE_CHATS = 'UPDATE_CHATS';

export const getExistingChats = () => (dispatch: any): any => {
	const token = getChatToken();
	return getChats(token)
		.then(chats => {
			dispatch({
				type: UPDATE_CHATS, payload: chats.map<ClientLocal>(x => ({
					...x,
					messages: x.lastMessages?.map(m => ({
						...m,
						time: DateTime.fromISO(m.time)
					})) ?? []
				}))
			});
		})
}
